import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3943bfaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["graph"]

import {
  onMounted,
  ref,
  onUnmounted,
  watchEffect,
  computed,
} from "vue";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4chart from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import _, { reduce } from "lodash";
import { userUseStore } from "@/store/user";
import { each } from "@amcharts/amcharts4/.internal/core/utils/Iterator";
import { useOptionStore } from "@/store/option";
import { celsiusToFahrenheit, kgToPound } from "@/util/unit";


export default /*#__PURE__*/_defineComponent({
  props: {
  graph: {
    type: Array,
    default: () => [],
  },
},
  setup(__props) {

const props = __props



const userStore = userUseStore();
const optionStore = useOptionStore();

const chartRef = ref<any>(null);

const chartData = computed(() => {
  return props.graph.map((data: any) => {
    if (optionStore.isMetricUnit) {
      return data;
    }

    return {
      ...data,
      weight: kgToPound(data.weight).toFixed(2),
      tank_temp: celsiusToFahrenheit(data.tank_temp),
      oil_heater_1_temperature: celsiusToFahrenheit(
        data.oil_heater_1_temperature
      ),
      oil_heater_2_temperature: celsiusToFahrenheit(
        data.oil_heater_2_temperature
      ),
      air_heater_1_temperature: celsiusToFahrenheit(
        data.air_heater_1_temperature
      ),
      air_heater_2_temperature: celsiusToFahrenheit(
        data.air_heater_2_temperature
      ),
      discharge_heater_temperature: celsiusToFahrenheit(
        data.discharge_heater_temperature
      ),
      tank_over_heating_detect_temperature: celsiusToFahrenheit(
        data.tank_over_heating_detect_temperature
      ),
    };
  });
});

// 원래 onMounted, watchEffect에 async 없음
onMounted(() => {
  // 차트 테스트 시작

  am4core.useTheme(am4themes_animated);

  const chart = am4core.create(chartRef.value, am4chart.XYChart);
  chart.data = [];
  chart.data = props.graph;

  // 그래프 및 라벨에 사용될 색 리스트(20가지 종류라 색도 20개)
  // 그래프의 수가 증가하고, 색을 변경하거나 추가할 경우 여기서 작업
  let colorSet = new am4core.ColorSet();
  chart.colors.list = [
    am4core.color("#0909FF"),
    am4core.color("#1E90FF"),
    am4core.color("#33CCCC"),
    am4core.color("#BDEDFF"),
    am4core.color("#4EE2EC"),
    am4core.color("#999966"),
    am4core.color("#9999FF"),
    am4core.color("#FF0099"),
    am4core.color("#FF9933"),
    am4core.color("#CC00FF"),
    am4core.color("#CC0000"),
    am4core.color("#FFFF66"),
    am4core.color("#FFCCCC"),
    am4core.color("#CCFFCC"),
    am4core.color("#32CD32"),
    am4core.color("#FFCC99"),
    am4core.color("#A0D6B4"),
    am4core.color("#C04000"),
    am4core.color("#E5788F"),
    am4core.color("#F9B7FF"),
  ];

  // Create chart instance
  // var chart = am4core.create("chartdiv", am4chart.XYChart);

  // Create axes
  var dateAxis = chart.xAxes.push(new am4chart.DateAxis());
  dateAxis.renderer.grid.template.location = 0;
  // Y축 범위 텍스트 글씨 하얀색
  dateAxis.renderer.labels.template.fill = "#fff";
  dateAxis.height = 160;

  var valueAxis = chart.yAxes.push(new am4chart.ValueAxis());
  // y축 최소값
  // valueAxis.min = 0;
  // X축 범위 텍스트 글씨 하얀색
  valueAxis.renderer.labels.template.fill = "#fff";
  valueAxis.height = 270;

  // Create series
  function createSeries(field, name) {
    var series = chart.series.push(new am4chart.LineSeries());
    series.dataFields.valueY = field;
    series.dataFields.dateX = "time";

    series.name = name;
    series.strokeWidth = 1;

    return series;
  }

  const weightSeries = createSeries("weight", "weight");
  const tankTempSeries = createSeries("tank_temp", "tank_temp");

  createSeries("operation_step", "operation_step");
  createSeries("oil_heater_1_temperature", "oil_heater_1_temperature");
  createSeries("oil_heater_2_temperature", "oil_heater_2_temperature");
  createSeries("air_heater_1_temperature", "air_heater_1_temperature");
  createSeries("air_heater_2_temperature", "air_heater_2_temperature");
  createSeries("error_input_weight_overload", "error_input_weight_overload");
  createSeries("error_oil_bi_metal", "error_oil_bi_metal");
  createSeries("error_air_bi_metal", "error_air_bi_metal");
  createSeries("error_motor_overload", "error_motor_overload");
  createSeries(
    "error_blower_pump_fan_overload",
    "error_blower_pump_fan_overload"
  );
  createSeries(
    "error_tank_temperature_over_heating",
    "error_tank_temperature_over_heating"
  );
  createSeries(
    "error_oil_heater_1_over_heating",
    "error_oil_heater_1_over_heating"
  );
  createSeries(
    "error_oil_heater_2_over_heating",
    "error_oil_heater_2_over_heating"
  );
  createSeries(
    "error_air_heater_1_over_heating",
    "error_air_heater_1_over_heating"
  );
  createSeries(
    "error_air_heater_2_over_heating",
    "error_air_heater_2_over_heating"
  );
  createSeries(
    "error_discharge_heater_over_heating",
    "error_discharge_heater_over_heating"
  );
  createSeries("error_emergency_stop", "error_emergency_stop");
  createSeries("error_lift_hydric_motor", "error_lift_hydric_motor");

  // 그래프 1개씩 ON/OFF 할 수 있는 줄
  // chart.legend = new am4chart.Legend();
  // 그래스 커서로 좌표읽기
  chart.cursor = new am4chart.XYCursor();

  // Create container to hold our hover labels
  var info = chart.plotContainer.createChild(am4core.Container);
  info.width = 1600;
  info.height = 100;
  info.x = 2 + "%";
  info.y = 115 + "%";
  info.layout = "grid";

  // Create labels
  function createLabel(field, title, color) {
    var titleLabel = info.createChild(am4core.Label);
    titleLabel.text = field + ":";
    titleLabel.marginRight = 5;
    titleLabel.fontWeight = "bolder";
    titleLabel.minWidth = 300;
    titleLabel.fill = color;

    var valueLabel = info.createChild(am4core.Label);
    valueLabel.id = title;
    valueLabel.text = "-";
    valueLabel.minWidth = 80;
    valueLabel.fontWeight = "bolder";
    valueLabel.fill = color;
  }

  chart.series.each(function (series) {
    createLabel(series.dataFields.valueY, series.name, series.stroke);
  });

  // Set up number format
  chart.numberFormatter.numberFormat = "#,###.00";
  // chart.numberFormatter.numberFormat = "#,###.00";

  // Show last item by default
  chart.events.on("ready", function (ev) {
    chart.series.each(function (series) {
      updateValues(series.dataItems.last, series.name);
    });
  });

  // Show overal close values when cursor is not shown
  chart.cursor.events.on("hidden", function (ev) {
    chart.series.each(function (series) {
      updateValues(series.dataItems.last, series.name);
    });
  });

  // Set up cursor's events to update the label
  chart.cursor.events.on("cursorpositionchanged", function (ev) {
    chart.series.each(function (series) {
      var dataItem = dateAxis.getSeriesDataItem(
        series,
        dateAxis.toAxisPosition(chart.cursor.xPosition),
        true
      );
      updateValues(dataItem, series.name);
    });
  });

  // Updates values(dataItem, key)
  function updateValues(dataItem, key) {
    chart.series.each(function (series) {
      var label = chart.map.getKey(key);
      label.text = chart.numberFormatter.format(dataItem["valueY"]);
    });
  }

  // 차트 테스트 종료
  watchEffect(() => {
    chart.data = [];

    chart.data = chartData.value;
  });

  onUnmounted(async () => {
    chart.dispose();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "chartRef",
    ref: chartRef,
    class: "chartView",
    graph: props.graph
  }, null, 8, _hoisted_1))
}
}

})